import { config } from 'core/config';
import { PixVariant } from 'core/payments/entities';

export const getPixContainerId = (pixVariant: PixVariant): string =>
  pixVariant === PixVariant.QR ? config.pixQrContainerId : config.pixAutomaticoContainerId;
